import React from 'react';
import PropTypes from 'prop-types';
import CustomCheckbox from '../../../common/CustomCheckbox';
import SmartPopover from '../../../common/smartPopover/SmartPopover';
import { I18n } from 'react-redux-i18n-lite';

export default class AssessableCheckbox extends React.Component {
  static propTypes = {
    activity: PropTypes.object,
    onClick: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.parentDiv = React.createRef();
    this.state = {
      visiblePopover: false
    };
  }

  showPopover = () => {
    this.setState({ visiblePopover: true });
  };

  hidePopover = () => {
    this.setState({ visiblePopover: false });
  };

  render() {
    const { activity } = this.props;

    return (
      <div ref={this.parentDiv} onMouseLeave={this.hidePopover} onMouseEnter={this.showPopover} style={{ width: 20 }}>
        <CustomCheckbox
          classes={'margin-bottom-20'}
          handleClick={this.props.onClick}
          handleChange={() => {}}
          checked={Boolean(!activity.disabled && (activity.assessable === undefined || activity.assessable))}
        />
        {activity.disabled && this.parentDiv.current && (
          <SmartPopover
            placement={'top'}
            node={this.parentDiv.current}
            visible={this.state.visiblePopover}
            message={I18n.t('gradebook.hiddenActivity')}
          />
        )}
      </div>
    );
  }
}
